import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["child", "itemId", "childValue", "ref"],
    _excluded2 = ["value", "onFocus"];
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef, useState, useCallback, useMemo, useEffect, cloneElement } from 'react';
import { deepMap } from './deep-map.js';
import { useResizeObserver } from './use-resize-observer.js'; // arrow (32) + shadow (10) + shadow blur (~8) + item focus outline (4)

var ARROW_AREA_WIDTH_IN_PX = 54;

function patchItemIfNeeded(_ref) {
  var child = _ref.child,
      itemId = _ref.itemId,
      childValue = _ref.childValue,
      ref = _ref.ref,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/cloneElement(child, _objectSpread({
    itemId: itemId,
    value: childValue,
    ref: ref
  }, restProps));
}

function calculateArrowsVisibility(scrollContainerEl) {
  // doing this because scrollContainerEl.scrollWidth returns a rounded value
  var scrollLeft = Math.round(scrollContainerEl.scrollLeft);
  var shouldShowAnyArrow = scrollContainerEl.offsetWidth < scrollContainerEl.scrollWidth; // in some browsers, fully scrolled element has `scrollLeft + offsetWidth === scrollWidth - 1`
  // so we take this measurement error into account

  var delta = 1;
  var showLeftArrow = shouldShowAnyArrow && scrollLeft > 0;
  var showRightArrow = shouldShowAnyArrow && scrollLeft + scrollContainerEl.offsetWidth < scrollContainerEl.scrollWidth - delta;
  return {
    showLeftArrow: showLeftArrow,
    showRightArrow: showRightArrow
  };
}

function scrollElementBy(element, to) {
  if (element.scrollBy) {
    element.scrollBy({
      top: 0,
      left: to,
      behavior: 'smooth'
    });
  } else {
    element.scrollLeft += to;
  }
}

function scrollElementLeft(element, to) {
  if (element.scrollTo) {
    element.scrollTo({
      top: 0,
      left: to,
      behavior: 'smooth'
    });
  } else {
    element.scrollLeft = to;
  }
}

function scrollIntoView(activeNode, parentNode) {
  var childWidth = activeNode.offsetWidth;
  var parentWidth = parentNode.offsetWidth;
  var parentStyles = getComputedStyle(parentNode);
  var parentMarginsOffset = parseInt(parentStyles.marginLeft, 10) + parseInt(parentStyles.marginRight, 10);
  var parentScrollLeft = parentNode.scrollLeft;
  var parentScrollWidth = parentNode.scrollWidth; // position of the left border in the container

  var activeNodeLeft = parentNode.offsetLeft + activeNode.offsetLeft; // position of the right border in the container

  var activeNodeRight = activeNodeLeft + childWidth; // position of the left border in relation to the viewport

  var activeNodeLeftOffset = activeNodeLeft - parentScrollLeft; // position of the right border in relation to the viewport

  var activeNodeRightOffset = parentWidth - (activeNodeLeftOffset + childWidth); // by default, don't scroll at all

  var scrollTo = -1; // if before the element there is a space larger than arrow area

  var isElHasWorkSpaceLeft = activeNodeLeft > ARROW_AREA_WIDTH_IN_PX; // if after the element there is a space larger than arrow area

  var isElHasWorkSpaceRight = activeNodeRight < parentScrollWidth - ARROW_AREA_WIDTH_IN_PX;

  if (activeNodeRightOffset <= ARROW_AREA_WIDTH_IN_PX) {
    if (isElHasWorkSpaceRight) {
      var sideOffset = parentWidth - childWidth + parentMarginsOffset;
      scrollTo = activeNodeLeft + ARROW_AREA_WIDTH_IN_PX - sideOffset;
    } else {
      scrollTo = parentScrollWidth - parentWidth; // right edge
    }
  } // left border has more priority when choosing which side to show


  if (activeNodeLeftOffset <= ARROW_AREA_WIDTH_IN_PX) {
    if (isElHasWorkSpaceLeft) {
      scrollTo = activeNodeLeft - ARROW_AREA_WIDTH_IN_PX - parentMarginsOffset;
    } else {
      scrollTo = 0; // left edge
    }
  }

  if (scrollTo >= 0) {
    scrollElementLeft(parentNode, scrollTo);
  }
}

var useScrollableList = function useScrollableList(_ref2) {
  var children = _ref2.children,
      compareValues = _ref2.compareValues,
      value = _ref2.value,
      CompareItem = _ref2.CompareItem;
  var activeNodeRef = useRef(null);
  var scrollableRef = useRef(null);
  var containerRef = useRef(null); // reset targeted element on scrolling by arrows
  // so on window resize there wouldn't scroll to it

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      targetedEl = _useState2[0],
      setTargetedEl = _useState2[1];

  var _useState3 = useState({
    showLeftArrow: false,
    showRightArrow: false
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      _useState4$ = _useState4[0],
      showLeftArrow = _useState4$.showLeftArrow,
      showRightArrow = _useState4$.showRightArrow,
      setShowArrows = _useState4[1];

  var _onFocus = useCallback(function (e) {
    setTargetedEl(e.target);
  }, []);

  var _useMemo = useMemo(function () {
    var counter = 0;
    var currentSelectedItemId = null;
    var items = deepMap(children, function (child) {
      if (child.type === CompareItem) {
        var _child$props = child.props,
            _child$props$value = _child$props.value,
            childValue = _child$props$value === void 0 ? counter : _child$props$value,
            onFocusFromProps = _child$props.onFocus,
            restProps = _objectWithoutProperties(_child$props, _excluded2);

        var hasAlreadySelectedItem = currentSelectedItemId === null;
        var isSelectedItem = hasAlreadySelectedItem && compareValues(value, childValue);

        if (isSelectedItem) {
          currentSelectedItemId = counter;
        }

        var patchedItem = patchItemIfNeeded(_objectSpread(_objectSpread({
          child: child,
          itemId: counter,
          childValue: childValue
        }, restProps), {}, {
          onFocus: function onFocus(e) {
            if (onFocusFromProps) {
              onFocusFromProps(e);
            }

            _onFocus(e);
          },
          ref: isSelectedItem ? activeNodeRef : null
        }));
        counter += 1;
        return patchedItem;
      } else {
        return child;
      }
    });
    return [React.Children.toArray(items), currentSelectedItemId];
  }, [children, value, compareValues, _onFocus, CompareItem]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      childrenWithValues = _useMemo2[0],
      selectedId = _useMemo2[1];

  var prepareDirectionScroller = function prepareDirectionScroller(direction) {
    return function () {
      var current = scrollableRef.current;
      var left = Math.max(current.clientWidth - 2 * ARROW_AREA_WIDTH_IN_PX, 30) * (direction === 'right' ? 1 : -1);
      setTargetedEl(null);
      scrollElementBy(current, left);
    };
  };

  useEffect(function () {
    if (!activeNodeRef.current) {
      return;
    }

    setTargetedEl(activeNodeRef.current);
  }, [value, childrenWithValues]);
  var setArrowsVisibility = useCallback(function () {
    if (!scrollableRef.current) {
      return;
    }

    setShowArrows(calculateArrowsVisibility(scrollableRef.current));
  }, []);
  var onPartsResize = useCallback(function () {
    var scrollableEl = scrollableRef.current;

    if (!scrollableEl) {
      return;
    }

    if (targetedEl) {
      scrollIntoView(targetedEl, scrollableEl);
    }

    setArrowsVisibility();
  }, [targetedEl, setArrowsVisibility]); // update arrows while smooth scrolling

  useEffect(function () {
    var scrollContainer = scrollableRef.current;

    if (!scrollContainer) {
      return null;
    }

    scrollContainer.addEventListener('scroll', setArrowsVisibility, {
      passive: true
    });
    return function () {
      return scrollContainer.removeEventListener('scroll', setArrowsVisibility);
    };
  }, [setArrowsVisibility]); // look at the containers resizes
  // onPartsResize will be called when its updates

  useResizeObserver(containerRef, onPartsResize);
  useResizeObserver(scrollableRef, onPartsResize);
  return {
    selectedId: selectedId,
    prepareDirectionScroller: prepareDirectionScroller,
    activeNodeRef: activeNodeRef,
    scrollableRef: scrollableRef,
    containerRef: containerRef,
    childrenWithValues: childrenWithValues,
    showLeftArrow: showLeftArrow,
    showRightArrow: showRightArrow
  };
};

export { useScrollableList };
